import { useEffect } from "react"

interface AbsoluteRedirectProps {
    url: string
}

export const AbsoluteRedirect: React.FC<AbsoluteRedirectProps> = ({url}) => {
    useEffect(() => {window.location.href = url});
    return null;
}